export const siteCopy = {
  en: {
    documentation: "Documentation",
    documentTitle: "SEPM Documentation",
    signOut: "Sign out",
    signInButton: "Sign in with SEPM",
    redirecting: "Redirecting…",
    heroEyebrow: "User manual",
    heroTitle: "SEPM X-Translator",
    heroText: "Workspace, formats, mapping, and transfers.",
    openManual: "Open the manual",
    subscription: "X-Translator subscription required",
    others: "Other guides",
    open: "Open",
    comingSoon: "Coming soon",
    copyright: "© Copyright SEPM",
    swTitle: "SEPM X-Translator SW",
    swSubtitle: "Smallworld",
    swText: "Installation and configuration for Smallworld.",
    aimsTitle: "AIMS Data Model Generator",
    aimsSubtitle: "Data modeling",
    aimsText: "PostGIS models, the wizard, and SQL generation.",
    portalTitle: "User and Subscription Portal",
    portalSubtitle: "Portal",
    portalText: "Users, subscriptions, and account administration.",
  },
  de: {
    documentation: "Dokumentation",
    documentTitle: "SEPM Dokumentation",
    signOut: "Abmelden",
    signInButton: "Mit SEPM anmelden",
    redirecting: "Weiterleitung…",
    heroEyebrow: "Benutzerhandbuch",
    heroTitle: "SEPM X-Translator",
    heroText: "Arbeitsbereich, Formate, Zuordnung und Transfers.",
    openManual: "Handbuch öffnen",
    subscription: "X-Translator-Abonnement erforderlich",
    others: "Weitere Anleitungen",
    open: "Öffnen",
    comingSoon: "Demnächst",
    copyright: "© Copyright SEPM",
    swTitle: "SEPM X-Translator SW",
    swSubtitle: "Smallworld",
    swText: "Installation und Konfiguration für Smallworld.",
    aimsTitle: "AIMS Data Model Generator",
    aimsSubtitle: "Datenmodellierung",
    aimsText: "PostGIS-Modelle, Assistent und SQL-Erzeugung.",
    portalTitle: "Benutzer- und Abonnementportal",
    portalSubtitle: "Portal",
    portalText: "Benutzer, Abonnements und Kontoverwaltung.",
  },
  fr: {
    documentation: "Documentation",
    documentTitle: "Documentation SEPM",
    signOut: "Se déconnecter",
    signInButton: "Se connecter avec SEPM",
    redirecting: "Redirection…",
    heroEyebrow: "Manuel utilisateur",
    heroTitle: "SEPM X-Translator",
    heroText: "Espace de travail, formats, correspondance et transferts.",
    openManual: "Ouvrir le manuel",
    subscription: "Abonnement X-Translator requis",
    others: "Autres guides",
    open: "Ouvrir",
    comingSoon: "Bientôt",
    copyright: "© Copyright SEPM",
    swTitle: "SEPM X-Translator SW",
    swSubtitle: "Smallworld",
    swText: "Installation et configuration pour Smallworld.",
    aimsTitle: "AIMS Data Model Generator",
    aimsSubtitle: "Modélisation",
    aimsText: "Modèles PostGIS, assistant et génération SQL.",
    portalTitle: "Portail utilisateurs et abonnements",
    portalSubtitle: "Portail",
    portalText: "Utilisateurs, abonnements et administration du compte.",
  },
};
